<template>
  <div>
    <p class="p-3 text-lg font-bold "><span class="typcn typcn-edit"></span> List Photo</p>
    <hr class="mt-1 mb-1">
    <form  @submit.prevent="submit">
      <div class="row justify-content-center">
        <div class="offset-1 col-9 p-2" style="font-size:12px;">
          <div class="shadow bg-white p-3 rounded-lg">
          <!-- INPUT -->
          <div class="sm-form">
            <input
              type="text"
              id="id"
              name="id"
              class="form-control form-control-sm"
              placeholder="id"
              v-model="dataphoto.id"
              disabled
            />
          </div>
          <div class="table-responsive">
            <table class="table table-sm table-striped table-bordered">
                 <tr>        
                    <td class="capitalize"><span class="typcn typcn-pen"></span> judul</td>
                    <td class="pl-2 pr-2">:</td>
                    <td>
                        <div class="sm-form ">
                            <input type="text" id="judul" name="judul" class="form-control form-control-sm" placeholder="judul" v-model="dataphoto.judul" >
                        </div>
                    </td>
                </tr>
                 <tr>        
                    <td class="capitalize">urutan</td>
                    <td class="pl-2 pr-2">:</td>
                    <td>
                        <div class="sm-form ">
                            <input type="number" id="urutan" name="urutan" class="form-control form-control-sm" placeholder="urutan" v-model="dataphoto.urutan" >
                        </div>
                    </td>
                </tr>
                 <tr>        
                    <td class="capitalize"><span class="typcn typcn-upload"></span> file</td>
                    <td class="pl-2 pr-2">:</td>
                    <td>
                        <div class="sm-form ">
                            <input type="file" @change="upload" id="filenya" name="username" class="form-control form-control-sm" placeholder="upload" >
                            <input type="text" id="gambar" name="gambar" class="form-control form-control-sm" placeholder="gambar" v-model="dataphoto.gambar">
                        </div>
                    </td>
                </tr>
            </table>    
          </div>
         <table>


         </table>
          <!-- END INPUT -->
          <!-- BUTTON PART -->
          <div class="mt-3 p-3">
            <button
              type="submit"
              class="btn btn-sm"
              :class="
                btn == 'tambah'
                  ? 'btn-primary'
                  : btn == 'update'
                  ? 'btn-success'
                  : 'btn-danger'
              "
            >
              <span class="typcn typcn-info"></span> Proses  {{ btn }}
            </button>
            <div class="float-right">
              <button
                type="button"
                v-show="btn!='tambah'"
                @click="
                  btn = 'tambah';
                  dataphoto = {};
                "
                class="btn btn-sm btn-dark"
              >
                <span class="typcn typcn-edit"></span> Tambah
              </button>
              <button
                type="button"
                @click="btn = 'delete'"
                v-show="btn!='tambah'"
                class="ml-3 btn btn-sm btn-danger"
              >
                <span class="typcn typcn-delete"></span> Delete
              </button>
            </div>
          </div>
          </div>
          <!-- END BUTTON PART -->
        </div>
        <div class="offset-1 col-9 p-2" style="font-size:12px;">
          <div class="shadow rounded-lg">
            <!-- TABLE PART -->
            <div v-if="datanya.length>0" class="p-2">
             <div class="text-right">
                <vue-json-excel :data="datanya">
                  <button type="button" class="btn btn-sm btn-dark">
                    Export <span class="typcn typcn-chart-area"></span>
                  </button>
                </vue-json-excel>
              </div>
                <Btables :tables="datanya"  :cari="['']" :hide="['']" @selected="ambil" ref="btable" />
            </div>
            <!-- END TABLE PART -->
         </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// TOTURIAL 
// ganti source autophp, ganti source component btable, ganti path table sdb
import autophp from "@/plugins/autophp_kasir.js"; // ganti source nya
import Btables from "@/components/Btables.vue"; //component btable nya
let sdb = new autophp();
export default {
  components: {
    Btables,
  },
  layout:"app_shop_admin",
  data() {
    return {
      selected: false,
      dataphoto: {},
      btn: "tambah",
      datanya:[],
    };
  },
  methods: {
    upload(){
        let file = document.querySelector("#filenya"); // berikan id pada input file
        sdb.collection('tbuser').upload(file).then(res=>{
            console.log(res)
            this.dataphoto.gambar=res;
            this.$forceUpdate();
        })
    },
    app_kasir_toko_listphoto(){
      this.$refs.btable.getData()
    },
    getData(){
      sdb.collection("app_kasir_toko_listphoto",false).doc().select(`select * from app_kasir_toko_listphoto`).then(res => {
        this.datanya=res;
        this.$forceUpdate();
      });
      
    },
    ambil(data) {
      this.dataphoto = data;
      this.btn = "update";
      this.$forceUpdate();
    },
    submit() {
      let that=this
      if (confirm("Apakah yakin proses dilanjutkan ?")) {
        if (this.btn == "tambah") {
          //idnya letak di dataphoto
          delete this.dataphoto.id;
          sdb
            .collection("app_kasir_toko_listphoto")
            .doc()
            .set(this.dataphoto)
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')

            });
        } else if (this.btn == "update") {
          sdb
            .collection("app_kasir_toko_listphoto")
            .doc()
            .set(this.dataphoto)
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')
            });
        } else if (this.btn == "delete") {
          sdb
            .collection("app_kasir_toko_listphoto")
            .doc(this.dataphoto.id)
            .delete()
            .then((res) => {
              that.getData();
            // that.nuxt.emit('getData')
            });
        }
        // this.nuxt.emit('getData','ok')
      }
    },
  },
  async mounted() {
    this.getData();
  },
};
</script>